// ================================================================================
// script-jquery.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for jQuery
// --------------------------------------------------------------- //

$(function() {

	$('.js-map-sites-toggle').click(function() {
		$(this).toggleClass('is-close');
		$(this).closest('.map-sites').find('.site-lists').slideToggle('fast');
	} );

});

